import store from '../store';

export const SERVER = (function () {
  const API_URL = process.env.REACT_APP_BASE_API_URL;
  // const PDF_URL = process.env.REACT_APP_PDF_URL;
  return {
    VELOCITY_GRAPH_DATA: (gameId, playerId, live) => {
      if (live) {
        return `${API_URL}/dataaccess/velocitygraph/${gameId}_${playerId}?isLive=yes`;
      } else {
        return `${API_URL}/dataaccess/velocitygraph/${gameId}_${playerId}?`;
      }
    },
    PRACTICE_VIEW_MODAL: (gameId, playerId) => {
      return `${API_URL}/dataaccess/highlights/${gameId}/post?entities=${playerId}&includePlayer=yes`;
    },
    PAST_PRACTICE_BALL_METRICS: (id, isMobile) => {
      if(isMobile){
        return `${API_URL}/dataaccess/mobile/ballflight/${id}/post?`;
      }
      return `${API_URL}/dataaccess/ballflight/${id}/post?`;
    },
    PAST_PRACTICE_ENTITIES: (id) => {
      return `${API_URL}/dataaccess/datasets/${id}/entities`;
    },
    PAST_PRACTICE_INFO: (id) => {
      return `${API_URL}/dataaccess/reports/${id}/post`;
    },
    ACCOUNT_TEAM_DATA: (id) => {
      return `${API_URL}/dataaccess/admin/${id}/settings`;
    },
    DATAACCESS_HIGHLIGHT: (gameId, isMobile) => {
      if(isMobile){
        return `${API_URL}/dataaccess/mobile/highlights/${gameId}/post`;
      }
      return `${API_URL}/dataaccess/highlights/${gameId}/post`;
    },
    PLAYER_PARTICIPATION:(gameId) =>{
      return `${API_URL}/dataaccess/highlights/${gameId}/playerparticipation`;
    },
    LIVE_PRACTICE_INFO: (id, isMobile) => {
      if(isMobile){
        return `${API_URL}/dataaccess/mobile/reports/${id}/live?`;
      }
      return `${API_URL}/dataaccess/reports/${id}/live?`;
    },
    LIVE_PRACTICE_ENTITIES: (id) => {
      return `${API_URL}/dataaccess/datasets/${id}/entities`;
    },
    LIVE_PRACTICE_BALL_METRICS: (id, isMobile) => {
      if(isMobile){
        return `${API_URL}/dataaccess/mobile/ballflight/${id}/live?`;
      }
      return `${API_URL}/dataaccess/ballflight/${id}/live?`;
    },
    LIVE_SPEEDS_UPDATE: (id) => {
      return `${API_URL}/dataaccess/correctspeedspike/${id}`;
    },
    ACCOUNT_SETTINGS: (id) => {
      return `${API_URL}/dataaccess/admin/${id}/settings?`;
    },
    PRACTICES: (teamId) => {
      return `${API_URL}/dataaccess/practices/${teamId}?`;
    },
    PLAYERS: (teamId) => {
      return `${API_URL}/dataaccess/practicerosters/${teamId}`;
    },
    PLAYER_METRICS: (idPlayer) => {
      return `${API_URL}/dataaccess/playermetrics/${idPlayer}/post?`;
    },
    CSV_REPORT: (dsId) => {
      return `${API_URL}/dataaccess/reports/csv/${dsId}?`;
    },
    CSV_INDIVIDUAL_EXPORT: (dsId, playerId, tzOffset) =>{
      return `${API_URL}/dataaccess/reports/csv/${dsId}?tzOffset=${tzOffset}&players=${playerId}&ViewMode=individuals`;
    },
    CSV_REPORT_BALLFLIGHTS: (dsId) => {
      return `${API_URL}/dataaccess/reports/csv/${dsId}/ballflights?`;
      // return `${API_URL}/dataaccess/reports/csv/20190711370100/ballflights`;
    },
    CSV_REPORT_BALLFLIGHTS_TOTALS: (dsId) => {
      return `${API_URL}/dataaccess/reports/csv/${dsId}/ballflights/totals?`;
    },
    /**
     * @Param bulkDataType. options: 'practices', 'games', 'practices,games'
     * @Param compareRange. format: yyyyMMdd-yyyyMMdd
     */
    CSV_REPORT_BULKDATA: (teamId, dsid, bulkDataType, compareRange) => {
      return `${API_URL}/dataaccess/reports/csv/${dsid}/playerbulk?teamId=${teamId}&bulkDataType=${bulkDataType}&compareRange=${compareRange}`;
    },
    CSV_REPORT_BULKDATA_TEAMS: (teamId, bulkDataType, compareRange) => {
      return `${API_URL}/dataaccess/reports/csv/${teamId}/teambulk?bulkDataType=${bulkDataType}&compareRange=${compareRange}`;
    },
    PLAYER_SEARCH: (league) => {
      return `${API_URL}/dataaccess/playerlist?league=${league}`;
    },
    NEW_SCHEDULE_LIST: (startTime, endTime, league, isSync, isMobile) => {
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}scheduledevents?league=${league}&startTime=${startTime}&endTime=${endTime}${isSync?'&isSync=true':''}`;
    },
    getPDFReport: (teamId, dateRange, gameId) => {
      return `${API_URL}/dataaccess/reports/pdf/${gameId}?teamId=${teamId}&compareRange=${dateRange}`;
    },
    GAMES: (teamId) => {
      return `${API_URL}/dataaccess/games/${teamId}?`;
    },
    IGNORE_PLAYS: (dsId) =>{
      return `${API_URL}/dataaccess/ignoreplaysforgame/${dsId}`;
    },
    REPROCESS_GAME: (dsId) =>{
      return `${API_URL}/dataaccess/reprocessgame/${dsId}`;
    },
    GAME_META: (gameId) => {
      return `${API_URL}/dataaccess/schedulegameid?gameId=${gameId}`;
    },
    GAMES_SCORE: (teamId) => {
      return `${API_URL}/dataaccess/scheduleteam?`;
    },
    PLAYER_MODAL_POST: (gameId) => {
      return `${API_URL}/dataaccess/highlights/${gameId}/`;
    },
    PLAYER_MODAL_LIVE: (gameId) => {
      return `${API_URL}/dataaccess/reports/${gameId}/live`;
    },
    GET_PLAYERS_NOTES: (gameId) =>{
      return `${API_URL}/dataaccess/playernotes/${gameId}?type=full`;
    },
    GET_PLAYER_NOTE: (gameId, playerId)=>{
      return `${API_URL}/dataaccess/playernotes/${gameId}/${playerId}`;
    },
    SET_PLAYER_NOTE: (gameId, playerId)=>{
      return `${API_URL}/dataaccess/playernotes/${gameId}/${playerId}`;
    },
    BALL_METRICS_MODAL: (gameId, live) => {
      return `${API_URL}/dataaccess/ballflight/${gameId}/${live? 'live' : 'post'}`;
    },
    // PLAYER_MODAL: (gameId, playerId, teamId) => {
    //   if (teamId) {
    //     return `${API_URL}/dataaccess/highlights/${gameId}/post?entities=${playerId}&includePlayer=yes&teamId=${teamId}` // &teamId=${teamId} for games
    //   }
    //   return `${API_URL}/dataaccess/highlights/${gameId}/post?entities=${playerId}&includePlayer=yes`
    // },
    ENTITIES_BY_TEAM: (byTeam) => {
      if (!byTeam) {
        return `${API_URL}/dataaccess/entitiesbysite/list?`;
      } else {
        return `${API_URL}/dataaccess/entitiesbyteam/list?`;
      }
    },
    ENTITIES_DATAOPS: (dsid) => {
      return `${API_URL}/dataaccess/datasets/${dsid}/entities?`;
    },
    CREATE_ENTITY_DATAOPS: (dsid) => {
      return `${API_URL}/dataaccess/datasets/${dsid}/entities?`;
    },
    EDIT_ENTITY_DATAOPS: (mongoId, dsid) => {
      return `${API_URL}/dataaccess/datasets/${dsid}/entities/${mongoId}?`;
    },
    DELETE_ENTITY_DATAOPS: (mongoId, dsid) => {
      return `${API_URL}/dataaccess/datasets/${dsid}entities/${mongoId}?`;
    },
    CREATE_ENTITY: () => {
      return `${API_URL}/dataaccess/entities?`;
    },
    DELETE_ENTITY: (mongoId) => {
      return `${API_URL}/dataaccess/entities/${mongoId}?`;
    },
    DELETE_ALL_ENTITIES_TAGS: (teamId) => {
      return `${API_URL}/dataaccess/roster/clearplayermappings/team/${teamId}`;
    },
    EDIT_ENTITY: (mongoId) => {
      return `${API_URL}/dataaccess/entities/${mongoId}?`;
    },
    MANAGE_GET: (mongoId, league, isMobile) => {
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}schedule/${mongoId}?league=${league}&type=practice&teamids=*`;
    },
    MANAGE_DELETE: (mongoId, teamId, league) => {
      return `${API_URL}/dataaccess/schedule/${mongoId}?league=${league}&type=practice&teamids=${teamId}`;
    },
    MANAGE_UPDATE: (mongoId, teamId, league, isMobile) => {
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}schedule/${mongoId}?league=${league}&type=practice&teamids=${teamId}`;
    },
    MANAGE_CHECK_REPLICA: (teamId, gameId, league) => {
      return `/dataaccess/dataset/${teamId}/checkreplica?league=${league}&type=practice&teamids=${teamId}&gameid=${gameId}`;
    },
    MANAGE_START_PRACTICE: (teamId, league) => {
      return `/dataaccess/datasets?league=${league}&type=practice&teamids=${teamId}`;
    },
    MANAGE_START_PRACTICE_MOBILE: (mongoId, teamId, league) => {
      return `${API_URL}/dataaccess/mobile/startpractice/${mongoId}?league=${league}&type=practice&teamids=${teamId}`;
    },
    MANAGE_STOP_PRACTICE: (teamId, league, isMobile) => {
      return `/dataaccess/${isMobile?'mobile/':''}dataset/${teamId}/stoppractice?league=${league}&type=practice&teamids=${teamId}`;
    },
    CREATE_COMBINE_OBJECT:(dsid) =>{
      return `${API_URL}/dataaccess/combine/event/${dsid}`;
    },
    UPDATE_COMBINE_OBJECT:(dsid, event_id) =>{
      return `${API_URL}/dataaccess/combine/event/${dsid}/${event_id}`;
    },
    FINALIZE_COMBINE:(dsid) =>{
      return `${API_URL}/dataaccess/combine/event/${dsid}/finalize`;
    },
    PUT_MONITOR_REVIEW_BY: (id, teamId, league, type) => {
      return `${API_URL}/dataaccess/schedule/${id}?league=${league}&type=${type}&teamids=${teamId}`;
    },
    HEALTH_VENUE_PROXY: (siteId) => {
      return `${API_URL}/dataaccess/health/venue/${siteId}`;
    },
    PROFILES: (isMobile) => `${API_URL}/dataaccess/${isMobile? 'mobile/': ''}profile/list?`,
    PROFILE: (teamId) => `${API_URL}/dataaccess/profile/list?teamids=${teamId}`,
    TEAMS: `${API_URL}/dataaccess/teamtables`,
    LOGIN: `${API_URL}/dataaccess/login`,
    LOGOUT: `${API_URL}/dataaccess/logout`,
    DATA_SETS: `${API_URL}/dataaccess/datasets`,
    VENUES:(isMobile) => `${API_URL}/dataaccess/${isMobile? 'mobile/': ''}venues`,
    SCHEDULE_LIST: `${API_URL}/dataaccess/schedule/list`,
    INTENSITIES: (teamId) => `${API_URL}/dataaccess/customintensity/${teamId}`,
    PERIOD_TYPES: (teamId) => `${API_URL}/dataaccess/customperiodtype/${teamId}`,
    CREATE_PRACTICE: (teamId, league, isMobile) => {
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}schedule?league=${league}&type=practice&teamids=${teamId}`;
    },
    GET_CUSTOM_EVENTS:(teamId, isMobile)=>{
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}customevents/${teamId}`;
    },
    SET_CUSTOM_EVENTS: (teamId, isMobile)=>{
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}customevents/${teamId}`;
    },
    GET_CUSTOM_TABLE:(user, live)=>{
      return `${API_URL}/dataaccess/userpreferences?${live? 'type=lc&':''}userId=${user.toLowerCase()}`;
    },
    SET_CUSTOM_TABLE: (user, live)=>{
      return `${API_URL}/dataaccess/userpreferences?${live? 'type=lc&':''}userId=${user.toLowerCase()}`;
    },
    SET_CUSTOM_ALERTS: (user, teamId)=>{
      return `${API_URL}/dataaccess/userpreferences?type=alerts&userId=${user.toLowerCase()}&teamOfInterest=${teamId}`;
    },
    GET_CUSTOM_ALERTS: (user, teamId)=>{
      return `${API_URL}/dataaccess/userpreferences?type=alerts&userId=${user.toLowerCase()}&teamOfInterest=${teamId}`;
    },
    GET_SPEED_ALERTS: (user, teamId)=>{
      return `${API_URL}/dataaccess/userpreferences?type=cmon&userId=${user.toLowerCase()}&teamOfInterest=${teamId}`;
    },
    SET_SPEED_ALERTS: (user, teamId)=>{
      return `${API_URL}/dataaccess/userpreferences?type=cmon&userId=${user.toLowerCase()}&teamOfInterest=${teamId}`;
    },
    MONITOR: (time) => { // time = 1573704000000
      return `${API_URL}/dataaccess/schedule/list?league=*&type=*&teamids=*&time=${time}&timeunit=day`;
    },
    CREATE_PROFILE: (league, teamId) => {
      return `${API_URL}/dataaccess/profile?league=${league}&type=practice&teamids=${teamId}`;
    },
    EDIT_PROFILE: (id, league, teamId) => {
      return `${API_URL}/dataaccess/profile/${id}?league=${league}&type=practice&teamids=${teamId}`;
    },
    DELETE_PROFILE: (id, league, teamId) => {
      return `${API_URL}/dataaccess/profile/${id}?league=${league}&type=practice&teamids=${teamId}`;
    },
    DATAOPS: () => {
      return `${API_URL}/dataaccess/datasets?`;
    },
    INIT_TRACK: (teamId) => {
      return `${API_URL}/dataaccess/dataset/${teamId}/dataops?`;
    },
    PRACTICE_SCHEDULE: (gameId, isMobile) => {
      return `${API_URL}/dataaccess/${isMobile?'mobile/':''}schedule/gameid/${gameId}`;
    },
    NFL_WEEKS: (season) => {
      return `${API_URL}/dataaccess/nflweeks?season=${season}`;
    },
    FULL_PRACTICE: (id) => {
      return `${API_URL}/dataaccess/fullpractice/${id}`; // ?teamId=2700&compareRange=20191218-20191218
    },
    PRACTICE_TRACK: (startTime, endTime, practiceId, datasetId) => {
      return `${API_URL}/dataaccess/venue/${practiceId}/tracks?startTime=${startTime}&endTime=${endTime}&datasetId=${datasetId}&compressed=true`;
    },
    VIEWER_PLAYERS: practiceId => {
      return `${API_URL}/dataaccess/venue/${practiceId}/playerlist?`;
    },
    TEAM_FIELDS: teamId => {
      return `${API_URL}/dataaccess/venue/${teamId}/practicearea?teamId=${teamId}`;
    },
    LOCAL_FIELDS_POST: teamId => {
      return `${API_URL}/dataaccess/venue/${teamId}/practicearea?`;
    },
    EDIT_FIELD: teamId => {
      return `${API_URL}/dataaccess/venue/${teamId}/practicearea/edit?`;
    },
    SPECIFIC_FIELD: (teamId, fieldId) => {
      return `${API_URL}/dataaccess/venue/${teamId}/practicearea?id=${fieldId}`;
    },
    ENTITIES_CONFLICT_REPORT_CSV: teamId => {
      return `${API_URL}/dataaccess/roster/nflgame/generateplayerconflictdatareportbyteam/${teamId}`;
    },
    PROCESSING_STATUS: (teamId, gameId, tzOffset, fullStatus) => {
      return `${API_URL}/dataaccess/processing/status/${teamId}${fullStatus? '&fullStatus=yes': ''}${tzOffset ? '&tzOffset=' + tzOffset : ''}${gameId ? '?datasetId=' + gameId : ''}`;
    },
    PARTIAL_REPROCESS: (gameId) =>{
      return  `${API_URL}/dataaccess/partialreprocess/${gameId}`;
    },
    ABOUT_DATA: () => {
      return `${API_URL}/dataaccess/about?`;
    },
    ABOUT_LEADERBOARDS : (filename) => {
      return `${API_URL}/dataaccess/about/leaderboards/${filename}?`;
    },
    ABOUT_USERGUIDE : (filename) => {
      return `${API_URL}/dataaccess/about/userguide/${filename}?`;
    },
    GET_EXCLUDE_PLAYERS: (dsid) => {
      return `${API_URL}/dataaccess/excludeplayers/${dsid}`;
    },
    SET_EXCLUDE_PLAYERS: () => {
      return `${API_URL}/dataaccess/excludeplayers`;
    },
    GET_USERS: () => {
      return `${API_URL}/dataaccess/usermanager/users`;
    },
    CREATE_USER: () => {
      return `${API_URL}/dataaccess/usermanager/users`;
    },
    UPDATE_USER: (userId) => {
      return `${API_URL}/dataaccess/usermanager/users/${userId}`;
    },
    DELETE_USER: (userId) => {
      return `${API_URL}/dataaccess/usermanager/users/${userId}`;
    },
    SEND_WELCOME_EMAIL: (userId) => {
      return `${API_URL}/dataaccess/usermanager/users/${userId}/welcome-email`;
    },
    GOOGLE_TOKEN: (authCode, redirectUri) => {
      return `${API_URL}/dataaccess/usermanager/google/token?authCode=${encodeURIComponent(authCode)}&redirectUri=${encodeURIComponent(redirectUri)}`;
    },
    GET_ROLES: () => {
      return `${API_URL}/dataaccess/usermanager/roles`;
    },
    CREATE_ROLE: () => {
      return `${API_URL}/dataaccess/usermanager/roles`;
    },
    UPDATE_ROLE: (roleId) => {
      return `${API_URL}/dataaccess/usermanager/roles/${roleId}`;
    },
    DELETE_ROLE: (roleId) => {
      return `${API_URL}/dataaccess/usermanager/roles/${roleId}`;
    },
  };
})();
const GET = {
  method: 'GET',
  headers: {
    id_token: store.getState().user.tokenId
  },
  credentials: 'include'
};
const GET_WITHOUT_INCLUDE = {
  method: 'GET',
  headers: {
    id_token: store.getState().user.tokenId
  }
};
export const OPTIONS = (process.env.REACT_APP_ENV === 'qa' ? GET_WITHOUT_INCLUDE : GET);
